export default {
  logLevel: import.meta.env.VITE_LOG_LEVEL || "error",
  backendURL: import.meta.env.VITE_BACKEND_URL,
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  downgradePlanLink: "https://form.jotform.com/232831829381057",
  enterprisePlanCalendlyLink: "https://calendly.com/elishamm/sales",
  smsSupportedCountriesRatesLink: "https://airtable.com/appPHvwaPfZcNhxBA/shrRMmEe1uenTlmGD/tbl18TLNTObZQRbTH/viwJkYzyqZanZJzgg",
  consensysTermsOfUse: "https://consensys.io/terms-of-use",
  consensysPrivacyPolicy: "https://consensys.io/privacy-notice",
  web3authACLDoc: "https://web3auth.io/docs",
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN || "",
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID || "",
  buildEnv: import.meta.env.VITE_BUILD_ENV,
  baseRoute: `${window.location.origin}/`,
  agenticAuthUrl: import.meta.env.VITE_AGENTIC_AUTH_URL || "https://oidc.api.cx.metamask.io",
  agenticAuthConnectionId: import.meta.env.VITE_AGENTIC_AUTH_CONNECTION_ID,
  agenticProdAuthConnectionId: import.meta.env.VITE_AGENTIC_PROD_AUTH_CONNECTION_ID,
  agenticAuthGroupedConnectionId: import.meta.env.VITE_AGENTIC_AUTH_GROUPED_CONNECTION_ID,
  agenticAuthClientId: import.meta.env.VITE_AGENTIC_AUTH_CLIENT_ID,
  agenticAuthUserIdField: import.meta.env.VITE_AGENTIC_AUTH_USER_ID_FIELD || "sub",
  mwpRelayUrl: import.meta.env.VITE_MWP_RELAY_URL || "wss://mm-sdk-relay.api.cx.metamask.io/connection/websocket",
  web3AuthChainsUrl: "https://assets.web3auth.io/v1/chains.json",
  web3AuthAssetsBaseUrl: "https://images.web3auth.io",
  infuraProxyUrl: "https://api.web3auth.io/infura-service/v1",
  segmentWriteKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
  agenticSegmentWriteKey: import.meta.env.VITE_AGENTIC_SEGMENT_WRITE_KEY,
};
